if(!customElements.get('custom-collection-product-list')){
    class CollectionProductList extends HTMLElement {

        constructor(){
            super();
            
            this.init();
        }

        init(){
            this.stickyFilterEnabled = this.dataset.stickyFilter === 'true';
            this.facetWrapper = this.querySelector('.collection-facet-wrapper');
            if(this.stickyFilterEnabled && this.facetWrapper && !this.stickyPlaceholder){
                this.stickyPlaceholder = document.createElement('div');
                this.stickyPlaceholder.className = 'collection-facet-wrapper-placeholder';
                this.stickyPlaceholder.setAttribute('aria-hidden', 'true');
                this.facetWrapper.insertAdjacentElement('afterend', this.stickyPlaceholder);
            }

            this.btnColumnSwitch = this.querySelector('.product-view-switch-wrapper');
            if(this.btnColumnSwitch){
                this.btnColumnSwitch.addEventListener('click', this.updateNumColumns.bind(this));
                this.btnColumnSwitch.addEventListener('keydown', e => {
                    if(e.key === 'Enter'){
                        this.updateNumColumns(e);
                    }
                });
            }

            if(this.stickyFilterEnabled){
                this.updateStickyFilter();
                window.addEventListener('scroll', this.updateStickyFilter.bind(this), { passive: true });
                window.addEventListener('resize', this.updateStickyFilter.bind(this));
            }
        }

        updateStickyFilter(){
            if(!this.facetWrapper || !this.stickyPlaceholder) return;

            const header = document.querySelector('custom-header');
            let offset = 0;

            if(header && header.dataset.sticky === 'true' && header.dataset.scroll === 'true'){
                offset += header.offsetHeight;
            }

            this.style.setProperty('--collection-sticky-offset', `${offset}px`);

            const barHeight = this.facetWrapper.offsetHeight;
            const listRect = this.getBoundingClientRect();
            const placeholderRect = this.stickyPlaceholder.getBoundingClientRect();
            const barOriginalTop = placeholderRect.top - barHeight;
            const shouldStick = barOriginalTop <= offset && listRect.bottom > offset + barHeight;

            if(shouldStick){
                const container = this.querySelector('.custom-container');
                const stickyRect = container ? container.getBoundingClientRect() : this.getBoundingClientRect();

                this.facetWrapper.setAttribute('data-sticky-active', 'true');
                this.facetWrapper.style.setProperty('--collection-sticky-container-left', `${stickyRect.left}px`);
                this.facetWrapper.style.setProperty('--collection-sticky-container-right', `${window.innerWidth - stickyRect.right}px`);
                this.stickyPlaceholder.style.height = `${barHeight}px`;
            }else{
                this.facetWrapper.setAttribute('data-sticky-active', 'false');
                this.facetWrapper.style.removeProperty('--collection-sticky-container-left');
                this.facetWrapper.style.removeProperty('--collection-sticky-container-right');
                this.stickyPlaceholder.style.height = '0px';
            }
        }

        updateNumColumns(){
            this.productCardWrapper = this.querySelectorAll('.product-card__wrapper');

            this.productCardWrapper.forEach(item => {
                if(this.btnColumnSwitch.dataset.column == '3'){
                    // update to 4 columns
                    item.classList.add('col-xl-4');
                    item.classList.add('col-12');
                    item.classList.remove('col-xl-3');
                    item.classList.remove('col-6');
                }else{
                    // update to 3 columns
                    item.classList.add('col-xl-3');
                    item.classList.add('col-6');
                    item.classList.remove('col-xl-4');
                    item.classList.remove('col-12');
                }
            });

            if(this.btnColumnSwitch.dataset.column == '4'){
                this.btnColumnSwitch.setAttribute('data-column', '3');
            }else{
                this.btnColumnSwitch.setAttribute('data-column', '4');
            }
        }
    }

    customElements.define('custom-collection-product-list', CollectionProductList);
}
